var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealTimeDataReportsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 47,
    viewBox: "0 0 55 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6942 1.97252L45.0169 21.0722L23.2935 44.4229L2.75479 23.4062L22.6942 1.97252Z",
    fill: "#62C191"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.1094,
    cy: 26,
    r: 16,
    fill: "#009A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealTimeDataReportsicon);
export default __webpack_public_path__ + "static/media/Real-time Data Reports icon.fa18f0850f35decf42957f1b06e36a0c.svg";
export { ForwardRef as ReactComponent };